module.exports = __webpack_public_path__ + "img/pin-imperial.999c9fb5.png";